import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export const importPassengersFormGroup = (formBuilder: FormBuilder): FormGroup => {
  return formBuilder.group({
    file: ['', Validators.required],
    allowWoEmailPhone: [''],
  });
};